import { WorkRequirementHoursScreen } from "@/interactors/WorkRequirementHoursScreen";

export default function WorkRequirementHours() {
  return <WorkRequirementHoursScreen />;
}
